import React, { Component } from 'react';
import { List, Card, Icon, Button, Tooltip, message } from 'utils/ui';
import { observer } from 'mobx-react';
import NavViews from '../stores/NavViews';
import UpcomingBirthday from './UpcomingBirthday';
import ModalShell from '../common/ModalShell';
import ModalBody from '../common/ModalBody';
import { FaBirthdayCake } from 'react-icons/fa';
import CopyToClipboard from 'react-copy-to-clipboard';
import CreateGroup from './CreateGroup';
const { Meta } = Card;
@observer(['FamilyStore', 'UserStore', 'CustomRouter'])
class MyFamily extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      inviteUrl: "list.gifts/invite/" + this.props.FamilyStore.activeGroupId
    }
    this.showInviteModal = this.showInviteModal.bind(this);
    this.linkCopied = this.linkCopied.bind(this);
  }

  componentDidMount() {
    this.props.FamilyStore.setFamily(this.props.groupId, this.props.UserStore.user._id);
  }

  showInviteModal() {
    this.setState({ modalOpen: true });
  }

  closeModal() {
    this.setState({ modalOpen: false });
  }

  linkCopied() {
    this.setState({ modalOpen: false });
    message.success("Copied!", 0.7);
  }

  render() {
    const { FamilyStore, CustomRouter, UserStore } = this.props;
    const family = FamilyStore.family;
    const monthNames = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    const listItems = family.map((member) => {
    const month = monthNames[(member.birthMonth || 12) - 1] || "Dec";
    const imgSrc = member.profileImage === "" ? "img/default-user.png" : member.profileImage;
      return (
      <List.Item
        key={member._id.toString()}
        style={{
          padding: '8px 12px',
          display: "flex",
          justifyContent: "center"
        }}
      >
        <Card
          onClick={() => CustomRouter.router.goTo(NavViews.singleList, { userId: member._id })}
          bordered={false}
          style={{
        backgroundColor: "white",
        width: "100%",
        maxWidth: 300,
        border: `1px solid ${UserStore.theme().darkBackground}`,
        borderRadius: 16,
        padding: '20px 16px',
        boxShadow: "0 8px 24px rgba(16,24,40,0.12)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        transition: "all 200ms ease",
        cursor: "pointer",
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: "0 12px 28px rgba(16,24,40,0.16)"
        }
          }}
          bodyStyle={{ padding: 0, width: "100%" }}
        >
          <img
        alt={member.name}
        src={imgSrc}
        style={{
          width: "clamp(80px, 30vw, 120px)",
          height: "clamp(80px, 30vw, 120px)",
          objectFit: "cover",
          borderRadius: "50%",
          marginBottom: 16,
          border: `4px solid ${UserStore.theme().darkBackground}`,
          boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
        }}
          />

          <div
        className="AppFont"
        style={{
          fontWeight: 600,
          fontSize: "clamp(1.1rem, 2vw, 1.3rem)",
          color: UserStore.theme().font,
          lineHeight: 1.2,
          marginBottom: 8,
          wordBreak: "break-word"
        }}
          >
        {member.name}
          </div>

          <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
          color: "rgba(255,255,255,0.9)",
          fontSize: "clamp(0.9rem, 1.8vw, 1rem)",
          padding: '6px 12px',
          background: UserStore.theme().icons,
          borderRadius: 20,
          marginTop: 8
        }}
          >
        <FaBirthdayCake style={{ fontSize: '0.9em' }} />
        <span>{month} {member.birthDay}</span>
          </div>
        </Card>
      </List.Item>
      );
    });
     const menuButtonStyle = {
        border: 'none',
        textAlign: 'center',
        padding: '15px',
        cursor: 'pointer',
        backgroundColor: UserStore.theme().icons || "white",
        color: UserStore.theme().font2 || "black",
        borderRadius: '40px',
        marginLeft: "5px",
        marginRight: "5px",
        marginTop: "5px"
    };
    return (
      <div>
      <ModalShell
        isOpen={this.state.modalOpen}
        onRequestClose={this.closeModal.bind(this)}
        className="register-modal"
        overlayClassName="register-modal-overlay"
        maxWidth={560}
      >
        <ModalBody title={`Invite people to ${FamilyStore.activeGroupName || "this group"}`} subtitle="Share this link so friends and family can join and add gift ideas." className="ui-modal-surface-compact">
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <div style={{ textAlign: 'left', color: '#374151', fontSize: '13px', background: '#f8fafc', borderRadius: '8px', padding: '10px 12px' }}>
          1. Copy the invite link.
          <br />
          2. Send it in text, email, or chat.
          <br />
          3. Ask them to open the link and create an account.
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '6px' }}>
          <div
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            padding: '10px 12px',
            background: '#f8fafc',
            border: '1px solid #e6edf3',
            borderRadius: '8px',
            wordBreak: 'break-all',
            fontSize: '14px',
            color: '#0f172a'
          }}
          title={UserStore.inviteUrl}
          >
          {UserStore.inviteUrl}
          </div>

          <CopyToClipboard onCopy={this.linkCopied} text={UserStore.inviteUrl}>
          <Tooltip placement="bottom" title="Copy invite link">
            <Button type="primary" style={{ borderRadius: '8px', padding: '6px 14px', boxShadow: 'none' }}>
            <Icon type="copy" /> Copy
            </Button>
          </Tooltip>
          </CopyToClipboard>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '6px' }}>
          <Button onClick={this.closeModal.bind(this)} style={{ marginRight: '8px', borderRadius: '8px' }}>
          Close
          </Button>
        </div>
        </div>
        </ModalBody>
      </ModalShell>
       <div style={{
          position: "fixed", 
          zIndex: 999, 
          width: "100%",
          padding: "10px 20px",
          backdropFilter: "blur(10px)",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          display: "flex",
          alignItems: "center"
      }}>
        <Button
          onClick={this.showInviteModal}
          style={{
            ...menuButtonStyle,
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '8px 12px',
            borderRadius: '8px',
            color: '#fff',
            cursor: 'pointer',
            userSelect: 'none',
            fontWeight: '600',
            transition: 'all 0.2s ease',
            boxShadow: '0 2px 4px rgba(74,144,226,0.2)'
          }}
        >
          <Icon type="user-add" /> Add Group Member
        </Button>
        <CreateGroup />
      </div>
      <div style={{ position: 'relative', top: '70px' }}>
         <UpcomingBirthday />
        {!FamilyStore.loaded ? (
          <Icon style={{ fontSize: '44px', color: '#1890ff' }} type="loading" />
        ) : (
          <List
          grid={{
            gutter: 16,
            xs: 1,
            sm: 2,
            md: 3,
            lg: 3,
            xl: 4,
            xxl: 5
          }}
          >
          {listItems}
          </List>
        )}
      </div>
     
      </div>
    )
  }
}
export default MyFamily;
